import styled from 'styled-components';

export default styled.div`
  .ant-col {
    display: flex;
    .ant-card {
      flex: 1;
      margin-bottom: 20px;
    }
  }
  .customer-requirements {
    img {
      max-width: 700px;
      min-width: 300px;
      object-fit: contain;
    }
  }
  .price {
    text-align: right;
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.primary};
  }
  .deadline {
    ${'' /* color: red; */}
    path {
      ${'' /* fill: red; */}
    }
  }
  .value {
    font-size: 20px;
    font-weight: bold;
  }
  .ant-divider {
    margin: 10px 0px;
  }
  .v-status {
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    width: 120px;
    align-self: flex-end;
    color: white;
    display: inline-block;
  }
  .actions {
    display: flex;
    align-items: center;
    .ant-select {
      width: 70%;
      max-width: 200px;
      .ant-select-selection {
        border: none;
        background: ${({ color }) => color};
        .ant-select-selection-selected-value {
          font-size: 20px;
          font-weight: 700;
          color: ${({ textColor }) => textColor};
        }
        svg {
          fill: ${({ textColor }) => textColor};
        }
      }
    }
  }
  .actions-payment {
    .ant-select {
      .ant-select-selection {
        background: ${({ paymentColor }) => paymentColor} !important;
        .ant-select-selection-selected-value {
          color: #fff;
        }
      }
    }
  }
  .submit-section {
    ${'' /* display: flex;
    justify-content: flex-end; */}
    .ant-btn {
      font-size: 20px;
      font-weight: 500;
      height: 40px;
    }
  }
`;
